import { SystemItem } from '@nx-customer-apps/api-planning-projects';

export const getLowTemperatureForNewSystem = (heatingSystem: SystemItem): boolean | undefined => {
    return !heatingSystem.isLowTemperatureOption && !heatingSystem.isLowTemperature ? undefined : heatingSystem.isLowTemperature;
};
